import { useIntl } from 'react-intl';

import { formatPhoneNumberForInput } from '@ocx/utils-phone-number';

import { formLabelMessages } from '../common/localization/form-label.messages';
import { TextField, TextFieldProps } from '../text-field';

export const PhoneNumberField = (props: TextFieldProps) => {
  const intl = useIntl();

  return (
    <TextField
      fullWidth
      type="tel"
      autoComplete="on"
      inputProps={{
        autoComplete: 'on',
      }}
      fieldProps={{
        format: formatPhoneNumberForInput,
      }}
      placeholder="(123) 456-7890"
      label={intl.formatMessage(formLabelMessages['form-label:phone-number'])}
      {...props}
    />
  );
};
